import {Directive, ElementRef, Input, OnChanges, Renderer2, SimpleChanges} from '@angular/core';

@Directive({
    selector: '[nextStepImage]',
})
export class NextStepImageDirective implements OnChanges {

    @Input() currentFlow;
    @Input() stepNumber;
    @Input() allStepData;
    imagePath = 'assets/svg/redesign/nodes/right-panel/';
    constructor(private elementRef: ElementRef, private renderer: Renderer2) {}

    ngOnChanges(changes: SimpleChanges): void {
        const stepNumberCamelLower = this.stepNumber.toLowerCase().replace(' ', '');
        if (stepNumberCamelLower === 'nextstep') {
            this.elementRef.nativeElement.src = `${this.imagePath}${this.allStepData[this.stepNumber.replace(' ', '')].nodeType}.svg`;
        } else if (stepNumberCamelLower === 'newstep' || stepNumberCamelLower === "optional") {
            this.elementRef.nativeElement.src = '../../../../../../assets/svg/redesign/nodes/right-panel/new.svg';
        } else {
            this.setNodeImage(stepNumberCamelLower);
        }
    }

    private setNodeImage(stepNumberCamelLower: string) {
        if (this.currentFlow[stepNumberCamelLower]
                && (this.currentFlow[stepNumberCamelLower].action
                && this.currentFlow[stepNumberCamelLower].action.actionType === 'chatHub')
        ) {
            this.elementRef.nativeElement.src = this.currentFlow[stepNumberCamelLower].action.actionParams.chathub.imageUrl;
            this.setImageClassName();
        } else {
            this.elementRef.nativeElement.src = `${this.imagePath}${this.allStepData[stepNumberCamelLower].nodeType}.svg`;
        }
    }

    private setImageClassName() {
        if (this.elementRef.nativeElement.classList.contains('select-image')) {
            this.renderer.addClass(this.elementRef.nativeElement, 'chat-hub-select-img');
        } else {
            this.renderer.addClass(this.elementRef.nativeElement, 'external-img');
        }
    }
}
